import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'de': {
        global: {
            siteName: 'Leben mit Schizophrenie',
            title: 'Leben mit Schizophrenie – Informationsplattform für Angehörige',
            description: 'Erfahrungen, Meinungen und Wissen von Peers/Betroffenen, Angehörigen sowie Fachpersonen zu häufigen Fragen zum Thema Schizophrenie.',
            ogTitel: 'Leben mit Schizophrenie',
            ogDescription: 'Leben mit Schizophrenie ist eine Informations- und Beratungsplattform für Angehörige und Bezugspersonen von Menschen mit Schizophrenie.',
            url: 'https://lebenmitschizophrenie.ch'
        },
        page: {
            next: 'Weiter',
        },
        questionSearch: {
            placeholder: 'Fragen durchsuchen',
        },
        questionCard: {
            linkBase: 'fragen-antworten',
            linkLabel: 'Mehr erfahren',
        },
        questionStatement: {
            portraitPrefix: 'Antwort von',
        },
        questionPage: {
            title: 'Fragen & Antworten',
            relatedQuestions: 'Weitere Fragen',
            allQuestions: 'Alle Fragen',
            seoTitle: 'Leben mit Schizophrenie – Fragen und Antworten',
            seoDescription: 'Peers/Betroffene, Angehörige sowie Fachpersonen beantworten häufige Fragen von Angehörigen und Bezugspersonen zum Thema Schizophrenie.',
            seoOgTitle: 'Leben mit Schizophrenie',
            seoOgDescription: 'Die Informationsplattform für Angehörige und Bezugspersonen von Menschen mit Schizophrenie.'
        },
        contributorQuestions: {
            path: 'autor',
            title: 'Antworten von',
            noElements: 'Dieser Autor hat noch keine Fragen beantwortet.',
            url: '/fragen-antworten/autor'
        },
        contributorOverview: {
            readMoreButton: 'Alle anzeigen',
        },
        offering: {
            moreInfo: 'weitere Informationen',
            statusDraft: 'Wartet auf Freigabe',
        },
        event: {
            moreInfo: 'weitere Informationen',
            from: 'ab',
            statusDraft: 'Wartet auf Freigabe',
        },
        project: {
            moreInfo: 'weitere Informationen',
            statusDraft: 'Wartet auf Freigabe',
        },
        offeringsBlock: {
            initialMessage: 'Treffen Sie oben eine Auswahl.',
            chooseCategory: 'Wählen Sie eine Kategorie',
            chooseLocation: 'Wählen Sie Ihre Region',
            noItems: 'Für diese Auswahl liegen keine Angebote vor. Bitte versuchen Sie eine andere Selektion.',
            loadMore: 'Mehr anzeigen',
        },
        eventsBlock: {
            noItems: 'Keine Veranstaltungen gefunden',
            loadMore: 'Mehr anzeigen',
        },
        projectsBlock: {
            noItems: 'Keine Projekte gefunden',
            loadMore: 'Mehr anzeigen',
        },
        contributorPortrait: {
            aboutMe: 'Über mich',
            contactMe: 'Kontakt aufnehmen',
            myAnswers: 'Meine Antworten',
            portrait: 'Portrait von',
        },
        contributorPage: {
            portrait: 'Portrait von',
            contact: 'Kontakt aufnehmen',
            myAnswers: 'Meine Antworten',
        },
        contactPage: {
            title: 'Kontakt&shy;aufnahme mit ',
            intro: 'For many of us, our very first experience of learning about the celestial bodies begins when we saw our first full moon in the sky. It is truly a magnificent view even to the naked eye. If the night is clear, you can see detail of the lunar surface just star gazing on in your back yard.',
            labelName: 'Name',
            placeholderName: 'Vorname Nachname',
            validationName: 'Bitte geben Sie Ihren Namen ein.',
            labelEmail: 'E-Mail',
            placeholderEmail: 'hallo@domain.ch',
            validationEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            labelMessage: 'Nachricht',
            placeholderMessage: 'Schreiben Sie Ihre Nachricht…',
            validationMessage: 'Bitte geben Sie eine Nachricht ein.',
            submitButton: 'Senden',
            validationError: 'Bitte überprüfen Sie Ihre Eingabe:',
            sendError: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
            sendSuccess: 'Vielen Dank für Ihre Nachricht. Die betreffende Person wird sich direkt mit Ihnen via E-Mail in Verbindung setzen.',
            subject: 'Kontaktaufnahme über lebenmitschizophrenie.ch',
        },
        siteFooter: {
            claim: 'Informationsplattform für Angehörige und Bezugspersonen',
            ownerTitle: 'Ein Projekt der:',
            supporterTitle: 'In Zusammenarbeit mit:'
        },
        notFound: {
            title: '404',
            message: 'Diese Seite gibt es leider nicht.'
        },
        cookieBanner: {
            message: 'Diese Webseite nutzt Cookies, um bestmögliche Funktionalität bieten zu können. Wenn Sie diese Webseite nutzen, akzeptieren Sie die Verwendung von Cookies. <br><a href="/datenschutzerklarung">Weitere Informationen</a>',
        },
        organisationOverview: {
            pageTitle: 'Inhalte bearbeiten',
            offeringSectionTitle: 'Hilfsangebote',
            offeringSectionLead: 'Hilfsangebote sind z.B. Anlaufstellen, Beratungsangebote, Treffen, Kurse oder Gruppen für Angehörige von Menschen mit Schizophrenie.',
            offeringAddNew: 'Neues Angebot erfassen',
            offeringNoItems: 'Keine Angebote erfasst',
            projectSectionTitle: 'Projekte',
            projectSectionLead: 'Projekte sind z.B. Vorhaben, Kampagnen, Forschungsarbeiten oder Entwicklungen zum Thema Schizophrenie.',
            projectAddNew: 'Neues Projekt erfassen',
            projectNoItems: 'Keine Projekte erfasst',
            eventSectionTitle: 'Veranstaltungen',
            eventSectionLead: 'Veranstaltungen sind z.B. Fach- und Kulturanlässe oder Diskussionsrunden zum Thema Schizophrenie.',
            eventAddNew: 'Neue Veranstaltung erfassen',
            eventNoItems: 'Keine Veranstaltungen erfasst',
            contact: 'Bei Fragen nehmen Sie mit uns per <a href="mailto:kontakt@lebenmitschiczophrenie.ch">E-Mail</a> Kontakt auf.'
        },
        offeringForm: {
            titleCreate: 'Neues Angebot erfassen',
            titleEdit: 'Angebot bearbeiten',
            formValidationError: 'Bitte überprüfen Sie Ihre Eingabe:',
            filedValidationMsgTitle: 'Bitte geben Sie einen Titel ein',
            filedValidationMsgLink: 'Bitte geben Sie eine gültigie URL ein (beginnend mit «https://» oder «http://»)',
            filedValidationMsgCategory: 'Bitte wählen Sie mindestens eine Kategorie',
            filedValidationMsgLocation: 'Bitte wählen Sie mindestens einen Kanton',
            sendError: 'Beim Speichern ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            inputLabelTitle: 'Titel',
            inputLabelDescription: 'Beschreibung (optional)',
            inputLabelLink: 'Link',
            inputLabelCategory: 'Kategorien',
            inputLabelLocation: 'Kantone',
            buttonSave: 'Speichern',
            buttonCancel: 'Abbrechen',
            loading: 'laden…',
            draftNote: 'Neue Einträge werden vom Projekt-Team zuerst überprüft, bevor sie publiziert werden.'
        },
        projectForm: {
            titleCreate: 'Neues Projekt erfassen',
            titleEdit: 'Projekt bearbeiten',
            formValidationError: 'Bitte überprüfen Sie Ihre Eingabe:',
            filedValidationMsgTitle: 'Bitte geben Sie einen Titel ein',
            filedValidationMsgLink: 'Bitte geben Sie eine gültigie URL ein (beginnend mit «https://»)',
            sendError: 'Beim Speichern ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            inputLabelTitle: 'Titel',
            inputLabelDescription: 'Beschreibung (optional)',
            inputLabelLink: 'Link',
            buttonSave: 'Speichern',
            buttonCancel: 'Abbrechen',
            loading: 'laden…',
            draftNote: 'Neue Einträge werden vom Projekt-Team zuerst überprüft, bevor sie publiziert werden.'
        },
        eventForm: {
            titleCreate: 'Neue Veranstaltung erfassen',
            titleEdit: 'Veranstaltung bearbeiten',
            formValidationError: 'Bitte überprüfen Sie Ihre Eingabe:',
            filedValidationMsgTitle: 'Bitte geben Sie einen Titel ein',
            filedValidationMsgLink: 'Bitte geben Sie eine gültigie URL ein (beginnend mit «https://»)',
            filedValidationMsgDates: 'Bitte geben Sie mindestens ein Datum ein',
            filedValidationMsgDate: 'Bitte geben Sie ein Datum in korrekter Formatierung ein (z.B. 31.12.2020)',
            sendError: 'Beim Speichern ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            inputLabelTitle: 'Titel',
            inputLabelDescription: 'Beschreibung (optional)',
            inputLabelLink: 'Link',
            inputLabelDates: 'Veranstaltungsdaten',
            addDateEntry: 'Weiteres Datum einfügen',
            buttonSave: 'Speichern',
            buttonCancel: 'Abbrechen',
            loading: 'laden…',
            draftNote: 'Neue Einträge werden vom Projekt-Team zuerst überprüft, bevor sie publiziert werden.'
        },
        organisationItemDelete: {
            title: 'Eintrag löschen?',
            msg: 'Möchten Sie den Eintrag «{title}» wirklich löschen?',
            buttonDelete: 'Löschen',
            buttonCancel: 'Abbrechen',
            loading: 'laden…',
        },
        consultingForm: {
            noticeLabel: 'Wichtige Informationen',
            formValidationError: 'Bitte überprüfen Sie Ihre Eingabe:',
            sendError: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
            inputLabelRole: 'Rolle',
            roleOptions: {
                noAnswer: 'Keine Angabe',
                parents: 'Eltern',
                sibling: 'Geschwister',
                child: 'Tochter/Sohn',
                relative: 'andere Familienangehörige',
                friend: 'Freundes-/Bekanntenkreis',
                work: 'Vorgesetzte',
                school: 'Lehrperson',
                neighbor: 'Nachbarschaft',
                other: 'andere Bezugspersonen'
            },
            inputLabelAge: 'Jahrgang',
            inputLabelKanton: 'Kanton',
            kantonOptions: {
                aargau: 'Aargau',
                appenzellAusserrhoden: 'Appenzell Ausserrhoden',
                appenzellInnerrhoden: 'Appenzell Innerrhoden',
                baselLandschaft: 'Basel-Landschaft',
                baselStadt: 'Basel-Stadt',
                bern: 'Bern',
                freiburg: 'Freiburg',
                genf: 'Genf',
                glarus: 'Glarus',
                graubuenden: 'Graubünden',
                jura: 'Jura',
                luzern: 'Luzern',
                neuenburg: 'Neuenburg',
                nidwalden: 'Nidwalden',
                obwalden: 'Obwalden',
                schaffhausen: 'Schaffhausen',
                schwyz: 'Schwyz',
                solothurn: 'Solothurn',
                stGallen: 'St. Gallen',
                tessin: 'Tessin',
                thurgau: 'Thurgau',
                uri: 'Uri',
                waadt: 'Waadt',
                wallis: 'Wallis',
                zug: 'Zug',
                zuerich: 'Zürich',
            },
            inputLabelGender: 'Geschlecht',
            genderOptions: {
                none: 'Keine Angabe',
                female: 'weiblich',
                male: 'männlich',
                other: 'divers'
            },
            telConsulting: 'Ich wünsche eine telefonische Beratung (wir rufen Sie in der Regel innerhalb von maximal 7 Tagen an).',
            videoCallConsulting: 'Ich wünsche ein trialogisches Beratungsgespräch (per Zoom), in dem ich meine Anfrage mit je einer:m Betroffenen, Angehörigen und Fachperson besprechen kann.',
            emailConsulting: 'Ich wünsche eine schriftliche Beratung per E-Mail',
            inputLabelTel: 'Telefonnummer*',
            inputLabelConsultingType: 'Beratungsart*',
            filedValidationMsgConsultingType: 'Bitte wählen Sie eine Beratungsart',
            filedValidationMsgTel: 'Bitte geben Sie eine Telefonnummer ein',
            inputLabelReachability: 'Erreichbarkeit',
            inputHelpReachability: '(Wochentage, Uhrzeiten)',
            inputLabelEmail: 'E-Mail-Adresse*',
            filedValidationMsgEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            inputLabelMessage: 'Anfrage*',
            filedValidationMsgMessage: 'Bitte geben Sie eine Nachricht ein',
            buttonSave: 'Abschicken',
            filedValidationMsgNutzungsbestimmungen: 'Bitte stimmen Sie den Nutzungsbedingungen zu.',
            filedValidationMsgDatenschutzrichtlinien: 'Bitte nehmen Sie die Datenschutzerklärung zur Kenntnis.',
            loading: 'senden…',
        },
        consultingConversation: {
            conversationPageTitle: 'Angehörigenbegleitung – Ihre Anfrage',
            conversationPageLead: 'Untenstehend finden Sie die Anfrage, welche Sie an die Angehörigenbegleitung von «Leben mit Schizophrenie» geschickt haben sowie die Antwort unseres Beratungsteams.',
            conversationItemTypeQuestion: 'Ihre Anfrage',
            conversationItemTypeAnswer: 'Unsere Antwort',
            conversationAnswerFormTitle: 'Neue Nachricht erfassen',
            conversationAnswerFormLead: 'Falls Sie dringende Rückfragen haben oder wieder mit uns Kontakt aufnehmen möchten, schreiben Sie bitte Ihre Nachricht hier',
            conversationAnswerFormButtonSave: 'Abschicken',
            conversationAnswerFormButtonLoading: 'speichern...',
            conversationAnswerFormValidation: 'Bitte geben Sie eine Nachricht ein',
            conversationAnswerFormSendError: 'Beim Senden ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
            conversationAnswerFormSendSuccess: 'Beim Senden ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        },
        consultingConfirm: {
            pageTitle: 'Angehörigenbegleitung – Ihre Anfrage',
            error: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an <a href="mailto:beratung@lebenmitschizophrenie.ch">beratung@lebenmitschizophrenie.ch</a>.',
        },
        articles: {
            'archiveUrl': 'schizophrenie',
            'baseUrl': 'artikel',
            'readMore': 'Weiterlesen',
        }
    },
};

const i18n = new VueI18n({
    locale: 'de',
    messages,
});

export default i18n;
